import { render, staticRenderFns } from "./modalPopup.vue?vue&type=template&id=1965b963&"
import script from "./modalPopup.vue?vue&type=script&lang=js&"
export * from "./modalPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports